module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLight.4d3fb3bc.ttf";